import { Outlet } from 'react-router-dom';

function Organs(){
    return(
        <Outlet/>
    );
}

export default Organs;
  